import { nonEmptyString } from "@/lib/utils";
import * as z from "zod";

export const shippingMethodSchema = z.object({
	id: nonEmptyString,
});

export type ShippingMethodSchema = z.infer<typeof shippingMethodSchema>;
